import React, {useContext, useEffect, useRef, useState} from "react";
import {useMapsLibrary} from "@vis.gl/react-google-maps";
import {StoreLocatorContext} from "../context/store-locator";


interface SearchProps {
    search: Function,
    toggleHideResult: Function
}


const parseGooglePlace = (result: google.maps.places.PlaceResult): any => {
    if (result.address_components === undefined) return {type: 'address'}
    for (const part of result.address_components) {
        for(const type of part.types){
            switch (type){
                case "route": return {type:'address'}
                case "locality": return {type:'city','name':part.short_name};
                case "country": return {type:'country','name':part.short_name}
            }
        }
    }
    return {type: 'address'}
}

const Search: React.FC<SearchProps> = (props) => {
    const [placeAutocomplete, setPlaceAutocomplete] =
        useState<google.maps.places.Autocomplete | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);
    const places = useMapsLibrary('places');

    useEffect(() => {
        if (!places || !inputRef.current) return;
        const options = {
            types: ['geocode'],
            fields: ['geometry', 'name', 'address_components']
        };
        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
    }, [places]);

    useEffect(() => {
        if (!placeAutocomplete) return;

        placeAutocomplete.addListener('place_changed', () => {
            const place = placeAutocomplete.getPlace();
            const typeSearch = parseGooglePlace(place);

            if (place.geometry) {
                props.search({
                    coords: {
                        lng: place.geometry.location?.lng() ?? 0,
                        lat: place.geometry.location?.lat() ?? 0,
                    },
                    type:typeSearch.type,
                    query:typeSearch.name??''
                });
            }
        });
    }, [placeAutocomplete]);


    return (
        <div className={'store-locator-search'}>
            <button className={'show-map-button'} onClick={() => props.toggleHideResult()}>
                <span className={'icon-mapo_2'}></span>
            </button>
            <div className="address-input-holder">
                <input type="search" ref={inputRef}/>
                <button type="submit" className="icon-search locator-search"></button>
            </div>
        </div>
    )
}

export default Search;
